import { useCallback, useEffect, useState } from 'react';
export const useFakeProgress = _ref => {
  let {
    initialProgress = 0.1,
    interval = 5000,
    edgeTimeout = 1000,
    updateProgressFn = currentProgress => currentProgress + (1 - currentProgress) / 3
  } = _ref;
  const [progress, setProgress] = useState(null);
  useEffect(() => {
    if (!progress) {
      return;
    }
    const intervalId = setInterval(() => setProgress(prevProgress => updateProgressFn(prevProgress ?? 0)), interval);
    return () => {
      clearInterval(intervalId);
    };
  }, [interval, progress, updateProgressFn]);
  const startProgress = useCallback(() => {
    setProgress(initialProgress);
  }, [initialProgress]);
  const finishProgress = useCallback(callback => {
    setProgress(1);
    setTimeout(callback, edgeTimeout);
  }, [edgeTimeout]);
  return {
    progress: progress ?? 0,
    startProgress,
    finishProgress
  };
};
//# sourceMappingURL=useFakeProgress.js.map